/*
 * Cart count pill.
 */

export default {
  baseStyle: {
    textTransform: 'none',
  },
  variants: {
    notification: {
      alignItems: 'center',
      backgroundColor: 'brandColors.primaryText',
      border: 'none',
      borderRadius: 'full',
      boxSizing: 'border-box',
      color: 'white',
      display: 'inline-flex',
      fontFeatureSettings: "'lnum' 1, 'pnum' 1",
      fontSize: '11px',
      fontWeight: 500,
      height: '16px',
      justifyContent: 'center',
      left: 'calc(50% + 8px)',
      lineHeight: 1.2,
      minWidth: '16px',
      paddingX: 0,
      paddingY: '3px',
      position: 'absolute',
      textTransform: 'none',
      top: 'calc(50% + 8px)',
      transform: 'translate(-50%, -50%)',
      width: '16px',
    },
  },
};
